import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, P } from '@a-type/ui';
import { useContext, useEffect, useState } from 'react';
import { VerdantContext } from '../verdant.js';
export function ResetNotifier({}) {
    const [shown, setShown] = useState(false);
    const client = useContext(VerdantContext);
    useEffect(() => {
        return client === null || client === void 0 ? void 0 : client.subscribe('resetToServer', () => {
            setShown(true);
        });
    }, [client]);
    const [waiting, setWaiting] = useState(false);
    useEffect(() => {
        if (shown) {
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setWaiting(true);
            const timeout = setTimeout(() => {
                setWaiting(false);
                setShown(false);
            }, 5000);
            return () => clearTimeout(timeout);
        }
    }, [shown]);
    return (_jsx(Dialog, { open: shown, onOpenChange: setShown, children: _jsxs(Dialog.Content, { children: [_jsx(Dialog.Title, { children: "Catching up..." }), _jsx(P, { children: "It's been a while since you've used this app. Fetching the latest data from the server!" }), _jsx(Dialog.Actions, { children: _jsx(Dialog.Close, { render: _jsx(Button, { loading: waiting }), children: "Ok" }) })] }) }));
}
//# sourceMappingURL=ResetNotifier.js.map